import * as types from "./types";
import { resolve, reject } from "../../middleware/simple-promise";

const initialState = {
  data: [],
  next: null,
  hasMore: true,
  mappingDetails: {},
  searchResults: [],
  searching: false,
  hasMoreResults: true,
  loading: false,
  saving: false
};

export default (state = initialState, action) => {
  const { type, payload, meta } = action;
  switch (type) {
    case types.RESET:
      return {
        ...state,
        next: null,
        data: [],
        hasMore: true
      };
    case types.LOAD_MAPPINGS:
      return {
        ...state,
        data: payload.next ? state.data : [],
        loading: true
      };
    case resolve(types.LOAD_MAPPINGS):
      return {
        ...state,
        data: [...state.data, ...payload.results],
        next: payload.next,
        hasMore: !!payload.next,
        loading: false
      };
    case types.GET_MAPPING:
      return {
        ...state,
        mappingDetails: {
          ...state.mappingDetails,
          loading: true
        }
      };
    case resolve(types.GET_MAPPING): {
      return {
        ...state,
        mappingDetails: {
          ...state.mappingDetails,
          loading: false,
          [meta.id]: payload
        }
      };
    }
    case types.SAVE_MAPPING:
    case types.UPDATE_MAPPING:
      return {
        ...state,
        saving: true
      };
    case resolve(types.SAVE_MAPPING):
    case resolve(types.UPDATE_MAPPING):
      let found = false;
      const data = state.data.map(i => {
        if (i.id === payload.id) {
          found = true;
          return payload;
        }
        return i;
      });

      if (!found) {
        data.push(payload);
      }

      const details = state.mappingDetails[payload.id] || {};

      return {
        ...state,
        saving: false,
        mappingDetails: {
          ...state.mappingDetails,
          [payload.id]: {
            ...details,
            ...payload
          }
        },
        searchResults: state.searchResults.map(r =>
          r.id === payload.id ? payload : r
        ),
        data
      };
    case reject(types.SAVE_MAPPING):
    case reject(types.UPDATE_MAPPING):
      return {
        ...state,
        saving: false
      };
    case resolve(types.DELETE_MAPPING):
      return {
        ...state,
        data: state.data.filter(m => m.id !== meta.id)
      };
    case types.SEARCH_MAPPING:
      return {
        ...state,
        searching: true,
        searchResults: []
      };
    case resolve(types.SEARCH_MAPPING):
      return {
        ...state,
        searchResults: payload,
        hasMoreResults: payload.length === 10,
        searching: false
      };
    case reject(types.SEARCH_MAPPING):
      return {
        ...state,
        searching: false
      };
    case types.CLEAR_SEARCH_MAPPING:
      return {
        ...state,
        searchResults: []
      };
    default:
      return state;
  }
};
